export const NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED";
export const SOFTWARE_TOKEN_MFA = "SOFTWARE_TOKEN_MFA"

export const LIST_HANDLE_CHALLENGE_NAME = [NEW_PASSWORD_REQUIRED, SOFTWARE_TOKEN_MFA]

export const ERROR_CODE_AUTH_COGNITO = {
  USER_NOT_FOUND_EXCEPTION:"UserNotFoundException",
  NOT_AUTHORIZED_EXCEPTION:"NotAuthorizedException",
  INVALID_PASSWORD_EXCEPTION:"InvalidPasswordException",
  CODE_MISMATCH_EXCEPTION:"CodeMismatchException",
  LIMIT_EXCEEDED_EXCEPTION:"LimitExceededException"
}